import React, { useContext } from 'react';
import { Platform } from '@theme/tokens';

export const PlatformContext = React.createContext<Platform>('web');
export const usePlatform = () => useContext(PlatformContext);
